import { z } from 'zod';

/** The one system folder. Named here so backend and frontend can't disagree. */
export const EXPENSES_FOLDER_SLUG = 'expenses' as const;

export const MAX_JOB_FOLDER_NAME_LENGTH = 80;

export const jobFolderSchema = z.object({
  id: z.string().uuid(),
  jobId: z.string().uuid(),
  name: z.string().min(1),
  /** null for a root folder; the holding folder's id for a subfolder. */
  parentFolderId: z.string().uuid().nullable(),
  /** null for user-made folders; a stable slug for system folders. */
  slug: z.string().nullable(),
  /** Files directly in this folder — not including those in its subfolders. */
  fileCount: z.number().int().nonnegative(),
  /** Folders directly inside this one. */
  subfolderCount: z.number().int().nonnegative(),
  createdAt: z.string(),
});
export type JobFolder = z.infer<typeof jobFolderSchema>;

export const createJobFolderSchema = z.object({
  name: z.string().trim().min(1, 'Name the folder.').max(MAX_JOB_FOLDER_NAME_LENGTH),
  /** Omitted for a root folder. The server rejects a parent that is itself nested. */
  parentFolderId: z.string().uuid().optional(),
});
export type CreateJobFolderInput = z.infer<typeof createJobFolderSchema>;

// Deliberately not an alias of create: a rename must not be able to smuggle in
// a parent and become a reparent. Moving folders is a separate ticket.
export const renameJobFolderSchema = z.object({
  name: z.string().trim().min(1, 'Name the folder.').max(MAX_JOB_FOLDER_NAME_LENGTH),
});
export type RenameJobFolderInput = z.infer<typeof renameJobFolderSchema>;
